'use-strict'
import app from '../../../data/base';
import moment, { normalizeUnits } from 'moment';

const validateRequiredField = (inputvalue) => {
    if(inputvalue==null || inputvalue==''){
        return false;
    }else
        return true;
}

const validateRelatore = (inputobject, isedit) => {
    const result = [];

    if(!validateRequiredField(inputobject.name)){
        result.push({field : 'Nome', error : 'Campo obbligatorio'});
    }
    
    if(!validateRequiredField(inputobject.surname)){
        result.push({field : 'Cognome', error : 'Campo obbligatorio'});
    }    

    if(inputobject.speakerGroups && !validateRequiredField(inputobject.speakerGroups[0].id)){
        result.push({field : 'Gruppo relatori', error : 'Campo obbligatorio'});
    }

    return result;

}


const relatori = {
    auth: {
        onAuthStateChanged: app.auth.onAuthStateChanged
    },
    methods : {
      callserver : app.methods.callserver,
      validateRelatore : validateRelatore,

    }
  };
  export default relatori;
